module.exports = __webpack_public_path__ + "img/glassquality_7.f21a72a5.png";